<template>
  <v-select :value="selected_causes" v-bind:items="incidentcauses" item-value="code" item-text="description"
    :label="label" :clearable="isClearable" :multiple="isMultiple" prepend-icon="mdi-filter-outline"
    @change="updateData">
    <template v-slot:prepend-item>
      <v-list-item ripple @mousedown.prevent @click="toggle">
        <v-list-item-action>
          <v-icon :color="selected_causes.length > 0 ? 'indigo darken-4' : ''">{{ icon }}</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Select All</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="mt-2"></v-divider>
    </template>
    <template v-slot:selection="{ item, index }">
      <v-chip small v-if="index >= 0 && index < visibleChips">
        <span>{{ item.description }}</span>
      </v-chip>
      <span v-if="index === visibleChips" class="grey--text text-caption">(+{{ selected_causes.length - visibleChips
        }})</span>
    </template>
  </v-select>
</template>

<script>
export default {
  props: {
    selected_causes: {
      type: Array,
      default: function () { return []; },
    },
    label: {
      type: String,
      default: 'Caused by'
    },
    field: {
      default: 'cause',
      required: true,
    },
    isClearable: {
      type: Boolean,
      default: false
    },
    isMultiple: {
      type: Boolean,
      default: true
    },
    visibleChips: {
      type: Number,
      default: 3
    }
  },
  computed: {
    icon: function () {
      if (this.selectAll) return 'mdi-close-box'
      if (this.selectSome) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    selectAll: function () {
      return this.selected_causes.length === this.incidentcauses.length;
    },
    selectSome: function () {
      return this.selected_causes.length > 0 && !this.selectAll;
    },
  },
  data() {
    return {
      incidentcauses: [],
      selectedcauses: []
    }
  },
  created() {
    this.getIncidentCauses();
  },
  methods: {
    getIncidentCauses() {
      this.$axios
        .post("ares/json/ares/huov/hokl/getKloz.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getKloz"
          }
        })
        .then(res => {
          if (res.data.error) {
            this.showDialog('error', 'Error', res.data.error.message);
          } else {
            this.incidentcauses = res.data.getKloz;
            this.setInitialStatusSelection();
          }
        })
    },
    updateData(v) {
      this.$emit('updateData', { "field": this.field, "value": v === null ? '' : v })
    },
    setInitialStatusSelection() {
      this.incidentcauses.forEach(element => this.selectedcauses.push(element.code));
      this.updateData(this.selectedcauses); // send all
    },
    toggle() {
      this.$nextTick(() => {
        if (this.selectAll) {
          this.selectedcauses = [];
        } else {
          this.selectedcauses = this.incidentcauses.slice().map(element => element.code); // just get an array with codes
        }
        this.updateData(this.selectedcauses);
      })
    },
  }
}
</script>
